import { useSnapshot } from 'valtio';
import { callState } from './state';

function useCallState() {
  const state = useSnapshot(callState);
  return state;
}

export default useCallState;
